// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__-C_Vz","col":"styles_col__3g973","fulfillmentStatus":"styles_fulfillmentStatus__1M04i","emailCol":"styles_emailCol__19pc3"};